<div [class.hidden]="!show">
  <div class="loading"></div>
</div>
